import { render, staticRenderFns } from "./OtherPaymentMethods.vue?vue&type=template&id=0a065620&scoped=true"
import script from "./OtherPaymentMethods.vue?vue&type=script&lang=js"
export * from "./OtherPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./OtherPaymentMethods.vue?vue&type=style&index=0&id=0a065620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a065620",
  null
  
)

export default component.exports